import * as React from "react";

function MinusCircleIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 20 20" fill="currentColor" width="1em" height="1em" {...props}><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z" clipRule="evenodd" /></svg>;
}

export default MinusCircleIcon;